import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";
import ConfirmationModal from "../../Controls/ConfirmationModal";

const UnCluster = (props) => {
    const { AffiliateData , GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showUnClusterAlert, setUnClusterAlert] = useState(false);
    const [unClusterAlertObj, setunClusterAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Auto Routing',
    body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',
    btnOkText: 'Yes'});

    useEffect(() => {

        async function fetchData() {
            try{
                if (props.GridRowData === null || props.GridRowData.length <= 0) {
                    setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'Cluster Action', alertMsg: 'No request selected to perform Action.' , displayFooter:true});
                    setUnClusterAlert(true);
                }
                else {

                    let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
                    if(result)
                        setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes'}));
                    else UnClusteringAction();

                }
            }
            catch(err){console.log(err);}
        }

        fetchData();
        
    }, []);

    function UnClusteringAction() {
        const selectedGridData = props.GridRowData

                    const SelectedRecordsForARB = [];

                    for (let k = 0; k < selectedGridData.length; k++) {
                        if (selectedGridData[k].Route !== "") {
                            SelectedRecordsForARB.push({
                                PickupDateTime: selectedGridData[0].PickupDateTime,
                                AffiliateID: selectedGridData[k].iSRATSPID,
                                ServiceID: selectedGridData[k].ServiceID,
                                ScheduleID: String(selectedGridData[k].bIsSchedule).toLowerCase() === "true" ? String(selectedGridData[k].iScheduleID) : "-1",
                                Confirmation: selectedGridData[k].ConfirmationNo,
                                vManifestNumber: selectedGridData[k].vManifestNumber,
                                TripRequestStatus: selectedGridData[k].TripRequestStatus,
                                iAssignedVehicleId: String(selectedGridData[k].iAssignedVehicleId) === "" ? "-1" : String(selectedGridData[k].iAssignedVehicleId),
                                iAssignedDriverId: String(selectedGridData[k].AssignedDriverId) === "" ? "-1" : String(selectedGridData[k].AssignedDriverId),
                            });
                        }
                    }
        
                    if (SelectedRecordsForARB.length === 0) {
                        setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'Information', alertMsg: 'No grouped record is selected. Please select valid grouped record(s) to perform this action!' , displayFooter:true});
                        setUnClusterAlert(true);
                        return false;
                    }
        
                    if (props.showUnClusterActionCreate) {
                        UnClusterTrips();
                    }
    }

    const UnClusterTrips = async () => {

        const selectedGridData = props.GridRowData
        const affID = selectedGridData[0].iSRATSPID;
        let callBackURL = "";
        const arrObj = [];

        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        for (let k = 0; k < selectedGridData.length; k++) {
            if (selectedGridData[k].Route !== "") {
                arrObj.push({
                    PickupDateTime: selectedGridData[0].PickupDateTime,
                    AffiliateID: selectedGridData[k].iSRATSPID,
                    ServiceID: selectedGridData[k].ServiceID,
                    ScheduleID: String(selectedGridData[k].bIsSchedule).toLowerCase() === "true" ? String(selectedGridData[k].iScheduleID) : "-1",
                    Confirmation: selectedGridData[k].ConfirmationNo,
                    vManifestNumber: selectedGridData[k].vManifestNumber,
                    TripRequestStatus: selectedGridData[k].TripRequestStatus,
                    iAssignedVehicleId: String(selectedGridData[k].iAssignedVehicleId) === "" ? "-1" : String(selectedGridData[k].iAssignedVehicleId),
                    iAssignedDriverId: String(selectedGridData[k].AssignedDriverId) === "" ? "-1" : String(selectedGridData[k].AssignedDriverId),
                });
            }
        }

        props.disbaleButton(true);
        let Param = {
            "affiliate_id": affID,
            "requested_page_name": "UnClusteringAction",
            "user_id": loginData.iUserID,
            "app_id": 26,
            "object_list": JSON.stringify(arrObj),
            "call_back_url": callBackURL
        }
        setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'Initializing UnClustering Process', alertMsg: 'Please Wait...' , displayFooter:true});
        setUnClusterAlert(true);
        props.disbaleButton(false);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Clustering/UnCluster", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if (result.run_id > 0) {
            setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'UnClustering Started', alertMsg: 'UnClustering is being performed...' , displayFooter:false});
            setUnClusterAlert(true);
            props.disbaleButton(false);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'Un-Cluster', alertMsg: result.error_message , displayFooter:true});
            setUnClusterAlert(true);
            props.disbaleButton(false);
        }
        else {
            setunClusterAlertObj({ ...unClusterAlertObj, alertTitle: 'Un-Cluster', alertMsg: 'Something went wrong !!!' , displayFooter:true});
            setUnClusterAlert(true);
            props.disbaleButton(false);
        }
    }

    const handleClusterAlertClose = () => {
        setUnClusterAlert(false);
        UnMountClusterComponent();
    }

    const UnMountClusterComponent = () => {
        if (props.showUnClusterActionCreate) {
            props.setUnClsuterActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () =>{
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setUnClsuterActionCreate(false);
        UnClusterTrips()
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setUnClsuterActionCreate(false);
    }
    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setUnClsuterActionCreate(false);
    }
    return (
        <>
            {showUnClusterAlert ? <Modal centered keyboard={false} backdrop="static" animation={true} show={showUnClusterAlert} onHide={handleClusterAlertClose} >
                <Modal.Header>
                    <Modal.Title>{unClusterAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{unClusterAlertObj.alertMsg}</b></Modal.Body>
                {unClusterAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClusterAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>:""}
            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                                   onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
                                   btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true"  />
        </>
    );

};

export default UnCluster;